import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { UsersService } from '../users/users.service';
import { AuthService } from '../../auth/auth.service';
import { environment as config } from '../../../../environments/environment';


@Component({
  selector: 'app-additional-configuration',
  templateUrl: './additional-configuration.component.html',
  styleUrls: ['./additional-configuration.component.scss']
})
export class AdditionalConfigurationComponent implements OnInit {
  public iframeUrl: SafeResourceUrl;
  public session: ISession;
  public isLoading: boolean = true;

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    public authService: AuthService,
    private usersService: UsersService,
  ) {}

  ngOnInit() {
    this.route.parent.data
      .map(route => route.data)
      .subscribe((session: ISession) => {
        this.session = session;
        this.usersService.getSpecialUsers(session.id).subscribe(specials => {
          const customer = this.authService.user ? this.authService.user.name : null;
          const emUser = specials.find((s: any) => s.type === 'H');
          if (!emUser) {
            console.log(`Event-Manager user not found for session: ${session.id}`);
          }          
          if (emUser) { 
            const url = `${config.livee.tag}/event/${customer}/h_${session.id}/l/BO-00-Liveeapp?autologin=true&jwt=${emUser.jwt}`;
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          }
          this.isLoading = false;          
        }, () => {
          this.isLoading = false;
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/additional-configuration/additional-configuration.component.ts